import { Injectable } from '@angular/core';

import { IGeographicalZonesApiClient } from './i-geographical-zones-api.client';
import { ApiClientProvider } from '../../../data-access';
import { GeographicalZonesInMemoryApiClient } from './geographical-zones.api.inmemory.client';
import { GeographicalZonesApiClient } from './geographical-zones-api.client';

@Injectable({
  providedIn: 'root'
})
export class GeographicalZonesApiClientProvider extends ApiClientProvider<IGeographicalZonesApiClient> {
  constructor(
    private client: GeographicalZonesApiClient,
    private inMemoryClient: GeographicalZonesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IGeographicalZonesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IGeographicalZonesApiClient {
    return this.client;
  }
}
